import type { LucideProps } from 'lucide-react'

import { cn } from 'src/shared/utils/cn'

type TabBarButtonProps = {
  icon: (props: LucideProps) => React.ReactNode
  title: string
  isActive: boolean
  onClick: () => void
}

const TabBarButton = ({ icon, title, isActive, onClick }: TabBarButtonProps) => {
  const Icon = icon
  return (
    <button
      className={cn(
        'flex h-[36px] flex-row items-center gap-1.5 rounded-full px-[15px] pb-[7px] pt-[6px] text-[#c6cbc9] transition-all duration-200 hover:bg-white/10',
        isActive && 'bg-white/25 hover:bg-white/25',
      )}
      onClick={onClick}
    >
      <div className="flex shrink-0 items-center justify-center rounded-[10px] transition-all duration-200">
        <Icon className={cn(isActive && 'text-white')} />
      </div>
      <span className={cn('text-[13px] font-medium leading-[1] transition-all duration-300', isActive && 'text-white')}>
        {title}
      </span>
    </button>
  )
}

export default TabBarButton
